import { PipeTransform, Pipe } from '@angular/core';
/* FILTRE KEYS
* Agafa un objecte amb determinades propietats i el transforma en una array de propietats per poder fer un LOOP.
*/
@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
    transform(value, args: string[]): any {
        let keys = [];
        try {
            console.groupCollapsed("KeysPipe");
            if (typeof (value) === "undefined") {
                return [];
            }
            for (let key in value) {
                console.debug(key);
                keys.push({ key: key, value: value[key] });
            }
            console.groupEnd();
            return keys;
        } catch (e) { }
        return [];
    }
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/filters/keys-filter.pipe.ts